module.exports = __webpack_public_path__ + "static/media/64.eeb2ac48.svg";